import { BaseComponents } from "./../../../base.component";
// import { NavigatorService } from './../statemanagement/navigator.service';
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Injector,
  signal,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ModalService } from "src/app/shared/service/modal/modal.service";
import { LineModalTemplateComponent } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.component";
import { LineModalTemplateService } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.service";
import { FormVerifyCustomerService } from "../services/form-verify-customer.service";
import { ResponseCodeVerifyCustomer, Customer } from "../models/customer.model";
import {
  encryptData,
  decryptData,
  getLiffNumber,
} from "../../../core/utilities";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiResponse } from "../models/response.model";
import { ConcentUrl } from "../models/concent.model";
import { ConcentService } from "../services/concent.service";
import {
  ResponseStateRegistration,
  ResponseStateLineID,
  VerifyLineID,
} from "../models/verify.model";
import { ResponseCodeRegistration } from "../models/registration.model";
import { FormRegistrationService } from "../services/form-registration.service";
import { LoaderService } from "../services/loader.service";
import { LineStateActionService } from "../statemanagement/line-state-action.service";
import { SetChannelAction } from "../statemanagement/action/channel.action";
import { SetIdentityAction } from "../statemanagement/action/identity.action";
import { Channel } from "../models/channel.model";
import { Identity, VerifyIdentity } from "../models/customer.model";
import { SetCustomerAction } from "../statemanagement/action/customer.action";
import { combineLatest } from "rxjs/operators";
import { LoggerService } from "../services/logger.service";
import { environment } from "src/environments/environment";
import { ReferenceService } from "src/app/services/reference.service";
import { GetMaskingService } from "src/app/adapters/getMasking.service";
import { validateThaiID } from "../../../core/thai-id.validator";
import liff from '@line/liff';
declare var UIkit: any;


@Component({
  selector: "app-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FormComponent extends BaseComponents implements OnInit {
  // @ViewChild('registerForm') registerForm: NgForm;
  registerForm!: FormGroup;
  model = {
    form: {
      idcard: { value: "", text: "" },
      mobile: { value: "", text: "" },
      lineId: { value: "", text: "" },
      chanelId: { value: "", text: "" },
      chanelLiffNumber: { value: "", text: "" },
      firstname: { value: "", text: "" },
      lastname: { value: "", text: "" },
      new_plateform_customer_flag: { value: null, text: "" },
    },
  };
  liffId: string;
  comCode: string;
  electronic_channel: number;
  regTel = /^0[1-9][0-9]{7,8}$/;

  channelRef = environment.sourceOfData;
  invalidInformation = signal<boolean>(false);
  inValidPhoneCount = 0;
  ref: string = "";
  liff_motor: string = "";
  flow: number;
  $concentState: BehaviorSubject<ApiResponse<ConcentUrl>> = new BehaviorSubject(
    null
  );
  concentUrlObservable: Observable<any> = this.$concentState.asObservable();
  log_session_text: string = "formcompenent";
  referenceUUID: string | null = null;
  constructor(
    protected injectorObj: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: ModalService,
    private lineModalService: LineModalTemplateService,
    private verifyCustomerService: FormVerifyCustomerService,
    private concentService: ConcentService,
    private formRegistrationService: FormRegistrationService,
    private loaderService: LoaderService,
    private lineStateAction: LineStateActionService,
    private lineActionService: LineStateActionService,
    private loggerService: LoggerService,
    private referenceService: ReferenceService,
    // private navigatorService : NavigatorService
    public getMaskingService: GetMaskingService,
    private fb: FormBuilder
  ) {
    super(injectorObj);
  }

  ngOnInit() {
    const funcName = "ngOnInit";
    this.registerForm = this.fb.group({
      idCard: [
        "",
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(13),
          Validators.pattern(/^\d{13}$/),
          validateThaiID
        ],
      ],
      mobile: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d{10}$/),
        ],
      ],
    });
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `formcomponent referenceUUID:[${this.referenceUUID}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    let channel = this.lineStateAction.channelStateInfo;
    this.logger.info(`${this.log_session_text} ${funcName} end`);
    this.route.queryParams.subscribe(async (params) => {
      this.ref = params.ref;
      this.liff_motor = params.liff_motor;
      this.flow = params.flow;
      this.logger.info(
        `${this.log_session_text} ${funcName} params:${JSON.stringify(params)}`
      );
    });
    if (!channel) {
      this.logger.info(
        `${this.log_session_text} ${funcName} channel not found go to page completed status fail`
      );

      this.router.navigate(["../completed"], {
        relativeTo: this.route,
        queryParams: { status: "fail", code: "E00008" },
      });
    }
    this.electronic_channel = channel.electronic_channel;
    this.logger.info(
      `${this.log_session_text} ${funcName} electronic_channel:${this.electronic_channel}`
    );
    this.lineStateAction.observableIdentity.subscribe();
  }

  onSubmit() {
    this.logger.info(`${this.log_session_text} onSubmit start`);
    try {
      if (this.registerForm.valid) {
      
        this.logger.info(`${this.log_session_text} onSubmit registerForm valid`);
        const formData = this.registerForm.value;
        this.loaderService.opendLoader();
        const idCard = formData.idCard ?? "";
        const phoneNumber = formData.mobile ?? "";
        this.logger.info(`${this.log_session_text} onSubmit set identity`);
        const identity: VerifyIdentity = {
          id_card: idCard,
          phone_number: phoneNumber,
          update_chanel_identity_flag: false,
          electronic_channel:
            this.lineStateAction?.channelStateInfo?.electronic_channel,
        };
        this.logger.info(
          `${this.log_session_text} onSubmit set identity success`
        );
        const log_identity = {
          ...identity,
          id_card: this.getMaskingService.maskingData(idCard),
          phone_number: this.getMaskingService.maskingData(phoneNumber),
        };
        this.logger.info(
          `${this.log_session_text} onSubmit identity:${JSON.stringify(
            log_identity
          )}`
        );
        this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
        this.logger.info(
          `${this.log_session_text} onSubmit call apiVerifyCustomer start`
        );
        this.verifyCustomerService
          .apiVerityCuestomer(identity)
          .subscribe({
            next: (result) => {
            this.logger.info(
              `${this.log_session_text} onSubmit call apiVerifyCustomer success result.state_code:${result?.state_code}`
            );
            console.log("result of responses: ", result);
            if (!result) return;
            switch (result.state_code) {
              case ResponseCodeVerifyCustomer.SUCCESS: {
                this.logger.info(
                  `${this.log_session_text} onSubmit verify customer success`
                );
                console.log("verify customer success");
                const customer: Customer = {
                  firstname: result.data.firstname,
                  lastname: result.data.lastname,
                  new_plateform_customer_flag:
                    result.data.new_plateform_customer_flag,
                };
                const log_customer = {
                  ...customer,
                  firstname: this.getMaskingService.maskingData(
                    customer.firstname
                  ),
                  lastname: this.getMaskingService.maskingData(
                    customer.lastname
                  ),
                };
                this.logger.info(
                  `${
                    this.log_session_text
                  } onSubmit verify customer success customer:${JSON.stringify(
                    log_customer
                  )}`
                );
                this.lineStateAction.sinkCustomer.next(
                  new SetCustomerAction(customer)
                );
                const channel = this.lineStateAction.channelStateInfo;
                this.logger.info(
                  `${
                    this.log_session_text
                  } onSubmit verify customer success channel:${JSON.stringify(
                    channel
                  )}`
                );
                const verifyLineData: VerifyLineID = {
                  ...identity,
                  ...customer,
                  ...channel,
                };
                console.log("line registration: ", verifyLineData);
                // const data:VerifyLineID = {
                //     "phone_number": identity.phone_number,
                //     "id_card": identity.id_card,
                //     "firstname": customer.firstname,
                //     "lastname": customer.lastname,
                //     "new_plateform_customer_flag": customer.new_plateform_customer_flag,
                //     "electronic_channel": 1,
                //     "application_channel_reference": this.model.form.chanelId.value,
                //     "channel_identity": this.model.form.lineId.value
                // }
                this.logger.info(
                  `${this.log_session_text} onSubmit verify customer success checkLineId start`
                );
                this.checkLineId(verifyLineData);
                break;
              }
              case ResponseCodeVerifyCustomer.NOTFOUND_IDCARD: {
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound idcard`
                );
                const channel = this.lineStateAction.channelStateInfo;
                const identity = this.lineStateAction.identityStateInfo;
                const data_send = {
                  ...channel,
                  ...identity,
                };
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound idcard verifyLinePreRegister start`
                );
                this.verifyLinePreRegister(data_send);
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound idcard verifyLinePreRegister end`
                );
                break;
              }
              case ResponseCodeVerifyCustomer.NOTFOUND_PHONE: {
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound_phone start`
                );
                this.loaderService.closeLoader();
                this.inValidPhoneCount++;
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound_phone inValidPhoneCount:${this.inValidPhoneCount}`
                );
                if (this.inValidPhoneCount == 5) {
                  this.logger.info(
                    `${this.log_session_text} onSubmit notfound_phone inValidPhoneCount==5 alert error`
                  );
                  this.modalService
                    .open(
                      LineModalTemplateComponent,
                      this.lineModalService.setModalConfig(
                        "alert",
                        "ไม่สามารถทำรายการได้",
                        [
                          "ท่านใส่ข้อมูลผิดเกินจำนวนครั้งที่กำหนด",
                          "กรุณาติดต่อเจ้าหน้าที่",
                        ]
                      )
                    )
                    .onResult()
                    .subscribe(
                      (closed) => {
                        console.log("closed", closed);
                        try {
                          liff.closeWindow();
                        } catch (err) {}
                      },
                      (dismissed) => {
                        console.log("dismissed", dismissed);
                        try {
                          liff.closeWindow();
                        } catch (err) {}
                      },
                      () => {
                        console.log(".");
                        try {
                          liff.closeWindow();
                        } catch (err) {}
                      }
                    );
                } else {
                  this.logger.info(
                    `${this.log_session_text} onSubmit notfound_phone inValidPhoneCount!== 5 alert error`
                  );
                  this.modalService
                    .open(
                      LineModalTemplateComponent,
                      this.lineModalService.setModalConfig(
                        "alert",
                        "ไม่สามารถทำรายการได้",
                        [
                          "ข้อมูลของท่านไม่ตรงกับในระบบ",
                          "กรุณากรอกใหม่อีกครั้ง",
                        ]
                      )
                    )
                    .onResult()
                    .subscribe(
                      (closed) => console.log("closed", closed),
                      (dismissed) => {
                        const mobileControl = this.registerForm.get('mobile');
                        if(mobileControl) {
                            mobileControl?.setValue("");
                            mobileControl?.markAsDirty();
                            mobileControl?.updateValueAndValidity();
                            this.model.form.mobile.value = "";
                            console.log("dismissed", dismissed);
                        }else {
                            this.logger.error(`${this.log_session_text} onSubmit mobileControl error`)
                        }
                      },
                      () => {
                        console.log(".");
                      }
                    );
                }
                this.invalidInformation.set(true);
                // this.router.navigate(['../mobile-verify'], { relativeTo: this.route });
                this.logger.info(
                  `${this.log_session_text} onSubmit notfound_phone end`
                );
                break;
              }
            }
            },
            error: (err) => {
              console.error(`${this.log_session_text} onSubmit call apiVerifyCustomer error:`,err);
              this.logger.info(`${this.log_session_text} onSubmit call apiVerifyCustomer error:${err?.message}`);
              this.loaderService.closeLoader();              
              this.modalService
                    .open(
                      LineModalTemplateComponent,
                      this.lineModalService.setModalConfig(
                        "alert",
                        "ไม่สามารถทำรายการได้",
                        [
                          "ขออภัย ระบบขัดข้อง","กรุณาติดต่อเจ้าหน้าที่",
                        ]
                      )
                    )
                    .onResult().subscribe({
                      next: (result2) => {
                        this.logger.info(`${this.log_session_text} onSubmit alert error apiVerityCuestomer`);
                      },
                      error: (err2) => {
                        this.logger.error(`${this.log_session_text} onSubmit alert error apiVerityCuestomer error:${err2?.message}`);
                      },
                      complete: () => {
                        this.logger.info(`${this.log_session_text} onSubmit alert error apiVerityCuestomer complete`);
                      }
                    })              
            },
            complete:() => {
              this.loaderService.closeLoader();
              this.logger.info(`${this.log_session_text} onSubmit call apiVerifyCustomer complete`)
            }
          });
      }else{
        this.registerForm.markAllAsTouched();
        this.logger.info(`${this.log_session_text} onSubmit registerForm invalid`);
      }
    } catch (error) {
      this.logger.error(
        `${this.log_session_text} onSubmit error:${error?.message}`
      );
      this.loaderService.closeLoader();
    }
  }

  async verifyLinePreRegister(payload) {
    this.logger.info(
      `${this.log_session_text} verifyLinePreRegister call apiVerifyPreRegistration start`
    );
    this.verifyCustomerService
      .apiVerifyPreRegistration(payload)
      .subscribe({
        next: (result) => {
        this.loaderService.closeLoader();
        if (result) {
          console.log("verify line pre regis result: ", result);
          this.logger.info(
            `${
              this.log_session_text
            } verifyLinePreRegister call apiVerifyPreRegistration result:${JSON.stringify(
              result
            )}`
          );
          switch (result.state_code) {
            case ResponseStateLineID.EX_LINE_ID: {
              const params = {
                update_channel_identity_flag: false,
                ref: this.ref,
                liff_motor: this.liff_motor,
                flow: this.flow,
              };
              this.logger.info(
                `${
                  this.log_session_text
                } verifyLinePreRegister call apiVerifyPreRegistration ex_line_id params:${JSON.stringify(
                  params
                )} goto page new-user`
              );
              const query = encryptData(
                this.b64EncodeUnicode(JSON.stringify(params))
              );
              this.router.navigate(["../new-user"], {
                relativeTo: this.route,
                queryParams: { params: query },
              });

              // data.update_channel_identity_flag = false;
              // const params = {
              //     update_channel_identity_flag: false
              // };
              // this.redirectConfirmOTP(params);
              // this.register(data);
              break;
            }
            case ResponseStateLineID.NEW_LINE_ID: {
              this.logger.info(
                `${this.log_session_text} verifyLinePreRegister call apiVerifyPreRegistration new_line_id goto page line-confirm`
              );
              const params = {
                state: "preregister",
              };
              // const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
              // this.router.navigate(['../new-user'], { relativeTo: this.route, queryParams: { params: query } });
              this.router.navigate(["../line-confirm"], {
                relativeTo: this.route,
                queryParams: params,
              });
              // ไลน์ไอดีใหม่
              // this.router.navigate(['../line-confirm'], { relativeTo: this.route });
              break;
            }
            default: {
              this.logger.info(
                `${this.log_session_text} verifyLinePreRegister flow default`
              );
            }
          }
        } else {
          this.logger.info(
            `${this.log_session_text} verifyLinePreRegister result is null`
          );
          this.invalidInformation.set(true);
          // this.router.navigate(['../mobile-verify'], { relativeTo: this.route });
          this.modalService
            .open(
              LineModalTemplateComponent,
              this.lineModalService.setModalConfig(
                "alert",
                "ไม่สามารถทำรายการได้",
                ["เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง"]
              )
            )
            .onResult()
            .subscribe(
              (closed) => console.log("closed", closed),
              (dismissed) => console.log("dismissed", dismissed),
              () => console.log(".")
            );
        }

        // console.log(result);
        },
        error: (err) => {
              console.error(`${this.log_session_text} onSubmit call apiVerifyPreRegistration error:`,err);
              this.loaderService.closeLoader();
              this.logger.info(`${this.log_session_text} onSubmit call apiVerifyPreRegistration error:${err.message}`);
        },
        complete:() => {
          this.loaderService.closeLoader();
          this.logger.info(`${this.log_session_text} onSubmit call verifyLinePreRegister complete`)
        }
      });
  }

  async checkLineId(payload) {
    console.log("payload ", payload);
    this.logger.info(
      `${this.log_session_text} checkLineId payload:${JSON.stringify(
        this.lineStateAction.channelStateInfo
      )}`
    );
    this.verifyCustomerService.apiVerifyLineID(payload).subscribe({
      next:(result) => {
      this.loaderService.closeLoader();
      console.log("result of verify line: ", result);
      this.logger.info(
        `${this.log_session_text} checkLineId result:${JSON.stringify(result)}`
      );

      const register = this.lineStateAction.customerStateInfo;
      const identity = this.lineStateAction.identityStateInfo;
      const channel = this.lineStateAction.channelStateInfo;
      console.log(identity);
      const data = {
        ...register,
        update_channel_identity_flag: false,
        ...identity,
        ...channel,
      };
      if (result) {
        switch (result.state_code) {
          case ResponseStateLineID.EX_LINE_ID: {
            data.update_channel_identity_flag = false;
            const params = {
              update_channel_identity_flag: false,
            };
            this.logger.info(
              `${
                this.log_session_text
              } checkLineId ex_line_id redirectConfirmOTP params:${JSON.stringify(
                params
              )}`
            );

            this.redirectConfirmOTP(params);
            // this.register(data);
            break;
          }
          case ResponseStateLineID.NEW_LINE_ID: {
            // ไลน์ไอดีใหม่
            this.logger.info(
              `${this.log_session_text} checkLineId new_line_id goto page line-confirm`
            );
            this.router.navigate(["../line-confirm"], {
              relativeTo: this.route,
            });
            break;
          }
          default: {
          }
        }
      } else {
        this.logger.info(
          `${this.log_session_text} apiVerifyLineID result is null`
        );
        this.invalidInformation.set(true);
        // this.router.navigate(['../mobile-verify'], { relativeTo: this.route });
        this.modalService
          .open(
            LineModalTemplateComponent,
            this.lineModalService.setModalConfig(
              "alert",
              "ไม่สามารถทำรายการได้",
              ["เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง"]
            )
          )
          .onResult()
          .subscribe(
            (closed) => console.log("closed", closed),
            (dismissed) => console.log("dismissed", dismissed),
            () => console.log(".")
          );
      }

      // console.log(result);
      },
      error: (err) => {
        console.error(`${this.log_session_text} checkLineId error:`,err);
        this.loaderService.closeLoader();
        this.logger.info(`${this.log_session_text} checkLineId error:${err.message}`);
      },
      complete: () => {
        this.loaderService.closeLoader();
        this.logger.info(`${this.log_session_text} onSubmit call apiVerifyCustomer complete`)
      }
    });
  }

  // async register(payload) {
  //     this.formRegistrationService.apiRegistration(payload).subscribe(
  //         result => {
  //             const json_res = JSON.stringify(result);
  //             alert(json_res);
  //             switch (result.state_code) {
  //                 case ResponseCodeRegistration.SUCCESS: {
  //                     let body = {
  //                         "comcode": this.comCode,
  //                         "cust_type": 1,
  //                         "id_no": this.model.form.idcard.value,
  //                         "first_name": this.model.form.firstname.value,
  //                         "last_name": this.model.form.lastname.value,
  //                         "line_channel_id": this.model.form.chanelId.value,
  //                         "line_user_id": this.model.form.lineId.value
  //                     }

  //                     this.concentService.apiConcentUrl(body).subscribe(result => {
  //                         // console.log(result);
  //                         if (result && result.status && result.data.token_url) {
  //                             console.log('url');
  //                             this.$concentState.next(result)
  //                         } else if (result && result.status) {
  //                             // port page
  //                         } else {
  //                             // throw error page or modal
  //                         }
  //                         console.log(result);
  //                     });
  //                 }
  //             }
  //         }
  //     )
  // }

  addClass(f: NgForm, field: string, type?: string, valueActive = "") {
    const iClass = [];
    if (f.form.get(field) && type !== "msg") {
      if (
        f.form.get(field).invalid &&
        (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)
      ) {
        iClass.push("uk-form-danger");
      } else if (
        f.form.get(field).valid &&
        (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)
      ) {
        if (valueActive === "") {
          iClass.push("uk-form-success");
        } else if (f.form.get(field).value === valueActive) {
          iClass.push("uk-form-success");
        }
      }
    } else if (f.form.get(field) && type === "msg") {
      if (
        f.form.get(field).invalid &&
        (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)
      ) {
        iClass.push("uk-animation-fade");
      } else if (
        f.form.get(field).valid &&
        (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)
      ) {
        iClass.push("uk-animation-reverse");
      }
    }

    return iClass;
  }

  validateIdCard = (value: string): Promise<boolean> => {
    if (value === "") {
      return Promise.resolve(false);
    }
    if (value != null && value.length < 13) {
      return Promise.resolve(false);
    }
    if (value != null && value.length === 13) {
      // STEP 1 - get only first 12 digits
      let idSum = 0;
      for (let i = 0; i < 12; i++) {
        // STEP 2 - multiply each digit with each index (reverse)
        // STEP 3 - sum multiply value together
        // tslint:disable-next-line: radix
        idSum += parseInt(value.charAt(i)) * (13 - i);
      }

      // STEP 4 - mod sum with 11
      const mod = idSum % 11;

      // STEP 5 - subtract 11 with mod, then mod 10 to get unit
      const check = (11 - mod) % 10;
      // STEP 6 - if check is match the digit 13th is correct
      // tslint:disable-next-line: radix
      if (check === parseInt(value.charAt(12))) {
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    }
    return Promise.resolve(true);
  };

  onKeyPress(params: any) {
    if (params.key === "Backspace" || params.key === ".") {
      return true;
    } else if (!this.isKeyPressedNumeric(params)) {
      return false;
    }
  }

  private isKeyPressedNumeric(event: any): boolean {
    const inputVal = document.getElementById("mobile") as HTMLInputElement;
    let input = inputVal.value;
    input = input + event.key;
    if (input.length >= 2) {
      const txtVal = input;
      return /^((\d{1,10}))$/.test(txtVal);
    }
    const charCode = this.getCharCode(event);
    const charStr = event.key ? event.key : String.fromCharCode(charCode);
    return this.isCharNumeric(charStr);
  }

  private getCharCode(event: any): any {
    event = event || window.event;
    return typeof event.which === "undefined" ? event.keyCode : event.which;
  }

  private isCharNumeric(charStr: any): boolean {
    let validation = false;

    if (charStr === ".") {
      validation = !!/\./.test(charStr);
    } else {
      validation = !!/\d/.test(charStr);
    }
    return validation;
  }

  private redirectConfirmOTP(param = null) {
    const params = {
      idcard: this.registerForm.get('idCard')?.value,
      mobile: this.registerForm.get('mobile')?.value,
      lineId: this.model.form.lineId.value,
      more: param,
      ref: this.ref,
      liff_motor: this.liff_motor,
      flow: this.flow,
    };
    const log_params = {
      ...params,
      idcard: this.getMaskingService.maskingData(params.idcard),
      mobile: this.getMaskingService.maskingData(params.mobile),
    };
    this.logger.info(
      `${this.log_session_text} redirectConfirmOTP params:${JSON.stringify(
        log_params
      )} and goto page confirm-otp`
    );
    const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
    this.router.navigate(["../confirm-otp"], {
      relativeTo: this.route,
      queryParams: { params: query },
    });
  }

  b64EncodeUnicode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }

  getPrimaryColor() {
    if (this.electronic_channel === 20) return "rgb(130, 188, 0)";
  }
}
